import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type { Packet } from '@/types/packet'

type PacketsResponse = {
  count: number
  results: Array<Packet>
}

type PacketParams = {
  page?: number
  pageSize?: number
  search?: string
  simplified?: string
  without_disabled?: string
}

export const loadPacketOptions = async <T>(params: T | PacketParams) => {
  const response = (await makeGetRequest(ApiBase + `/packets`, {
    params,
  })) as PacketsResponse

  return response.results.map((item) => ({
    label: item.name,
    value: item.id,
  }))
}
